import React, { useState } from 'react';
import './Office.css';

// Import office photos
import office1 from '../assets/office/bg-7c586e05.jpg';
import office2 from '../assets/office/bg-3c19f012.jpg';
import office3 from '../assets/office/bg-9c532271.jpg';
import office4 from '../assets/office/bg-4b170f26.jpg';
import office5 from '../assets/office/bg-abf62c85.jpg';
import office6 from '../assets/office/bg-f7c58c41.jpg';
import office7 from '../assets/office/bg-4fe64977.jpg';

const Office: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const officeImages = [
    { src: office1, alt: 'Modern reception area with comfortable seating' },
    { src: office2, alt: 'State-of-the-art treatment room' },
    { src: office3, alt: 'Consultation room with advanced technology' },
    { src: office4, alt: 'Comfortable patient waiting area' },
    { src: office5, alt: 'Professional orthodontic equipment' },
    { src: office6, alt: 'Clean and modern office environment' },
    { src: office7, alt: 'Welcoming office entrance' }
  ];

  return (
    <section className="office" id="office">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Our Modern Office</h2>
          <p className="section-subtitle">
            Experience orthodontic care in our comfortable, state-of-the-art facility.
            Our modern office is designed with your comfort and convenience in mind,
            featuring the latest technology and a welcoming atmosphere for patients of all ages.
          </p>
        </div>

        {/* Office Gallery */}
        <div className="office-gallery">
          <div className="gallery-main">
            <img
              src={officeImages[selectedImage].src}
              alt={officeImages[selectedImage].alt}
              className="main-image"
            />
          </div>
          <div className="gallery-thumbnails">
            {officeImages.map((image, index) => (
              <button
                key={index}
                className={`thumbnail ${index === selectedImage ? 'active' : ''}`}
                onClick={() => setSelectedImage(index)}
                aria-label={`View ${image.alt}`}
              >
                <img src={image.src} alt={image.alt} />
              </button>
            ))}
          </div>
        </div>

        {/* Office Information */}
        <div className="office-info">
          <div className="info-grid">
            {/* Contact Information */}
            <div className="info-card">
              <h3 className="info-card-title">Contact Information</h3>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-icon">👨‍⚕️</span>
                  <div className="contact-content">
                    <strong>Dr. Tom Ellerhorst DDS, MSD</strong>
                    <p>Board Certified Orthodontist</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <div className="contact-content">
                    <strong>Address</strong>
                    <p>256 North San Mateo Drive, Suite #1<br />San Mateo, CA 94401</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div className="contact-content">
                    <strong>Phone</strong>
                    <p><a href="tel:6503433603">(650) 343-3603</a></p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📠</span>
                  <div className="contact-content">
                    <strong>Fax</strong>
                    <p>(650) 343-0709</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Office Hours */}
            <div className="info-card">
              <h3 className="info-card-title">Office Hours</h3>
              <div className="hours-list">
                <div className="hours-item">
                  <span className="day">Monday - Thursday</span>
                  <span className="time">08:00 AM - 05:30 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Friday</span>
                  <span className="time">08:00 AM - 02:30 PM</span>
                </div>
                <div className="hours-item weekend">
                  <span className="day">Saturday - Sunday</span>
                  <span className="time">Closed</span>
                </div>
              </div>
              <div className="hours-note">
                <p><strong>Emergency appointments available</strong></p>
                <p>We understand dental emergencies can happen at any time. Please call our office for urgent care needs.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="office-cta">
          <h3 className="cta-title">Ready to Experience Our Modern Office?</h3>
          <p className="cta-subtitle">Complete your new patient registration and we'll schedule your visit to our state-of-the-art facility.</p>
          <button
            className="cta-button primary office-cta-button"
            onClick={() => {
              const element = document.getElementById('registration');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            aria-label="Complete your registration"
          >
            Start Registration
          </button>
        </div>
      </div>
    </section>
  );
};

export default Office; 